export const SHARED_BLOCK_FIELD_TYPES = new Set(['resource_link', 'page_link']);

export function isSharedBlockField(field) {
  return SHARED_BLOCK_FIELD_TYPES.has(field?.type);
}

export function isPresentSharedValue(value) {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string' && value.trim() === '') return false;
  return true;
}

export function canonicalSharedValue(plValue, enValue) {
  return isPresentSharedValue(plValue) ? plValue : enValue;
}

export function syncSharedBlockFields(dataPl, dataEn, fields) {
  (fields || []).forEach((field) => {
    if (!isSharedBlockField(field)) return;
    const name = field.name;
    const canonical = canonicalSharedValue(dataPl?.[name], dataEn?.[name]);
    if (dataPl) dataPl[name] = canonical ?? (field.type === 'page_link' ? null : '');
    if (dataEn) dataEn[name] = canonical ?? (field.type === 'page_link' ? null : '');
  });
}

export function sharedFieldValue(dataPl, dataEn, fieldName) {
  const canonical = canonicalSharedValue(dataPl?.[fieldName], dataEn?.[fieldName]);
  return canonical === undefined ? null : canonical;
}
